module.exports = __webpack_public_path__ + "static/media/icon-user-svg-white.61dd0672.svg";